import createdAddressBookMutation from "../../../../graphQl/mutations/createdAddressBook";

export const createAddressBook = async ({dispatch, rootGetters}, payload) => {
    const organizationId = rootGetters['app/getSelectedOrganization'].id;

    let createAddress;

    try {
        createAddress = await dispatch('app/request', {
            type: 'mutation',
            gql: createdAddressBookMutation,
            variables: {
                organizationId,
                ...payload,
            },
        }, {root: true});
    } catch (error) {
        return error;
    }

    if (createAddress.message) {
        throw createAddress.message;
    }

    if (createAddress.errors) {
        throw createAddress.errors;
    }

    return createAddress;
};